import { render } from "./CRMWhatsappContactFileDialog.vue?vue&type=template&id=31e85314"
import script from "./CRMWhatsappContactFileDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactFileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__